module.exports = __webpack_public_path__ + "media/CN_002.3ceadbbc.mp3";